import { createApp } from 'vue';
// Plugins
import VueSplide from '@splidejs/vue-splide';
import HeaderComponent from './components/Header.vue';
import OilFinder from './components/OilFinder.vue';
import HeroCarousel from './components/HeroCarousel.vue';
import HeaderSearch from './components/ui/HeaderSearch.vue';
import ProductListing from './components/ProductListing.vue';
import ProductDetail from './components/Product.vue';
import FindYourNearestStockistMap from './components/ui/FindYourNearestStockistMap.vue';
import LicensePlateEditOverlay from './components/ui/LicensePlateEditOverlay.vue';
const app = createApp({});
app.provide('apiBaseUrl', '/api/oil-finder'); // relative paths for trade site
app.provide('assetsPath', '/');
app.provide('redirectToPageAfterVehicleSelection', '/find-my-oil');
app.component('header-component', HeaderComponent);
app.component('oil-finder', OilFinder);
app.component('hero_carousel', HeroCarousel);
app.component('header_search', HeaderSearch);
app.component('product_listing', ProductListing);
app.component('product-detail', ProductDetail);
app.component('find-your-nearest-stockist-map', FindYourNearestStockistMap);
app.component('license-plate-edit-overlay', LicensePlateEditOverlay);
// PLugins
app.use(VueSplide);
app.mount('#app');
